import { useEffect, useState } from 'react'
import LavorisService from '../../services/LavorisService';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/combineReducer';
import { useAlert } from '../../hooks/useAlert';
import { useModal } from '../../hooks';
import { Modal } from '../../components/others/Modal';
import { useForm } from 'react-hook-form';
import Select from '../../components/others/Select/Select';
import InputRadio from '../../components/others/InputRadio/InputRadio';
import InputRadioType from '../../components/others/InputRadioType/InputRadioType';
import { Input } from '../../components/core/Input';
import { Button } from '../../components/core/Button';
import SearchSelectFetch from '../../components/others/SearchFetch';
import { PhoneNumber } from '../../utils/phoneNumber';
import { fetchAndFilterMoldes, fetchAndFilterPractices } from '../others/requestTurn/utils';
import { PillButton } from '../../components/others/PillButton';
import { ExamDetails, MoldeDetails, PracticesPillows } from '../others/AppointmentMetadata';
import { Practice } from '../../services/TurnServices/Turns.type';
import Textarea from '../../components/others/Textarea/Textarea';
import { SelectedFiles } from '../../components/others/FileUploader/FileUploader.types';
import DynamicFileUpload from '../../components/others/DynamicFileUpload';
import { PrimaryButton } from '../../components/others/ButtonPrimary';
import { getErrorMessage } from '../../utils';
import NewRequestsMultipleApplicantsModal from './NewRequestMultipleApplicants';
import NewRequestsMultipleEmployeesModal from './NewRequestMultipleEmployees';
import InputRadioCM from '../../components/others/InputCM/inputCM';
import { UpdatePersonalDataModal } from './UpdatePersonalDataModal';
import { SuccessModal } from '../../components/others/SuccessModal';
import "./request_turns.scss";

const REQUEST_TURN_MODAL = 'requestTurnModal';
const REQUEST_PRESTADOR_MODAL = 'requestPrestadorModal';
const UPDATE_PERSONAL_DATA_MODAL = 'updatePersonalDataModal';
const APPLICANTS_MULTIPLE_REQUEST_TURN_MODAL = 'applicantsMultipleRequestTurnModal';
const EMPLOYEES_MULTIPLE_REQUEST_TURN_MODAL = 'employeesMultipleRequestTurnModal';
const SUCCESS = 'succesPetition';

const NewRequestModal = (props: any) => {
    const controller = new AbortController();
    const signal = controller.signal;
    const LavorisInstance = LavorisService.getInstance();
    const { showAlert } = useAlert();
    const { openModal, isActive, closeModal } = useModal();
    const reduxStore = useSelector((state: RootState) => state.user);
    const chosenRole: string = reduxStore?.currentRole;
    const currentCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]);
    const [searchLoading, setSearchLoading] = useState<boolean>(false);
    const [type, setType] = useState<string>('Postulante')
    const [searchData, setSearchData] = useState<string>('')
    const [usersFound, setUsersFound] = useState<any | any[]>(null)
    const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
    const [selectedFiles, setSelectedFiles] = useState<SelectedFiles | null>(null);
    const [requestLoading, setRequestLoading] = useState<boolean>(false);
    const [updateEmailPhoneData, setUpdateEmailPhoneData] = useState<{ email: string, phoneNumber: string, name: string }>({ email: "", phoneNumber: "", name: "" });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [readOnlyInputRadio, setReadOnlyInputRadio] = useState(false);

    const searchUser = async () => {
        setSearchLoading(true)
        setUsersFound(null);
        setReadOnlyInputRadio(true);
        try {
            setSelectedEmployee(null)
            let isEmployee = type === 'Empleado';

            const response = isEmployee
                ? await LavorisInstance.CompanyServices.getEmployeeWithQuery(currentCompany?.id, searchData, signal)
                : await LavorisInstance.CompanyServices.getCandidatesWithQuery(searchData, signal);

            const data = Array.isArray(response) ? response : response.data;
            setUsersFound(data);
            if (data.length === 1) setSelectedEmployee(data[0]);
        } catch (error) {
            console.error(error);
        } finally {
            setSearchLoading(false);
        }
    }

    const {
        register,
        handleSubmit,
        resetField,
        setValue,
        control,
        watch,
        reset,
        getValues,
        formState: { errors }
    } = useForm({
        mode: 'all'
    });

    const [patient] = watch(['patient'])
    const [molde, exam, practicesSelected] = watch([
        "molde",
        "exam",
        "practicesSelected",
    ]);

    const handleTypeChange = (newType: string) => {
        setType(newType);
        setSearchData('');
        setUsersFound(null);
        setSelectedEmployee(null);
        setSelectedFiles(null);
        reset();
    };

    // Resetear searchLoading cuando el modal se abre
    useEffect(() => {
        if (props.show) {
            setSearchLoading(false);
        }
    }, [props.show]);

    useEffect(() => {
        const normalizeString = (str: any) => {
            return str
                .trim()
                .replace(/\s+/g, ' ')
                .toLowerCase();
        };

        const chosenEmployee = usersFound?.find((e: any) => {
            const ename = e?.name?.split(',')[1]?.trim();
            const elastname = e?.name?.split(',')[0]?.trim();
            const efullname = `${elastname}, ${ename}`;

            const pname = patient?.split(',')[1]?.trim();
            const plastname = patient?.split(',')[0]?.trim();
            const pfullname = `${plastname}, ${pname}`;
            return normalizeString(efullname) === normalizeString(pfullname);
        });

        setSelectedEmployee(chosenEmployee);
    }, [patient]);

    const updateUploadedFiles = (files: File[]) =>
        setSelectedFiles({ ...selectedFiles, profileImages: files });

    const uploadFile = async (id: string, selectedFile: File) => {
        await LavorisInstance.TurnServices.addFile(
            { file: selectedFile },
            id,
        ).catch((e: any) => console.log(e));
    };

    const onSubmit = async (data: any) => {
        setRequestLoading(true);
        try {
            const metadata = {
                exam: exam?.id,
                molde: molde?.id,
                practices: practicesSelected?.map((p: Practice) => p.id),
            };

            if (metadata.exam === undefined && metadata.molde === undefined && (metadata.practices === undefined || metadata.practices.length === 0)) {
                showAlert('Debe elegir un examen o una práctica para continuar')
                return;
            }

            const patientId = selectedEmployee && selectedEmployee !== undefined && selectedEmployee?.id
            const patientType = type === 'Postulante' ? 'COMPANY_CANDIDATE' : 'COMPANY_EMPLOYEE';
            const dataToSubmit = {
                observations: data.comments,
                patientType,
                patientId,
                metadata,
                has_cm: data.has_cm === 'Si' ? true : false,
                professional_cm: data.professional_cm || null,
                professional_license_cm: data.professional_license_cm || null,
                cm_date: data.cm_date || null,
                cm_days: data.cm_days || null
            };

            const res = await LavorisInstance.TurnServices.RequestTurnService(dataToSubmit)

            const filesToUpload = selectedFiles?.profileImages ?? [];
            if (res && filesToUpload.length) {
                await Promise.all(
                    filesToUpload.map((file) => uploadFile(res.appointment, file)),
                );
            }
            closeModal(REQUEST_TURN_MODAL);
            openModal(SUCCESS);
        } catch (err) {
            console.log(err)
            showAlert(getErrorMessage({ title: 'NO SE PUDO REALIZAR LA SOLICITUD.', err }))
        } finally {
            setRequestLoading(false);
        }
    };

    useEffect(() => {
        if (isSubmitted) {
            setSelectedEmployee({
                ...selectedEmployee,
                email: updateEmailPhoneData.email,
                phoneNumber: updateEmailPhoneData.phoneNumber,
                name: updateEmailPhoneData.name,
            })
            setIsSubmitted(false);
        }
    }, [isSubmitted])

    return (
        <div>
            <Modal
                show={props.show}
                modalTitle={props.modalTitle}
                urlTittle={props.urlTittle}
                onClose={props.onClose}
                titleStyle="modal-title-primary"
            >
                <div className="request-modal-content">
                    <form className='request-form' onSubmit={handleSubmit(onSubmit)}>
                    {/* Type Selection */}
                    <div className="form-section">
                        <InputRadioType
                            label="SELECCIONAR SEGÚN TIPO"
                            fieldName="type"
                            option1="Postulante"
                            option2="Empleado"
                            option1Legend="Estudios para ingresar al puesto"
                            option2Legend="Estudios para egreso y/o periódico, etc."
                            onChange={(e: any) => handleTypeChange(e)}
                            register={register}
                            defaultValue={'Postulante'}
                            //readOnly={readOnlyInputRadio}
                            error={errors?.type}
                        />
                    </div>

                    {/* Search Section */}
                    <div className="form-section">
                        <div className='search-user-group'>
                            <Input
                                type='text'
                                fieldName='searchuser'
                                label='Buscar por apellido, nombre o DNI'
                                register={register}
                                style={{ width: '100%', height: '90px' }}
                                onChange={(e: any) => setSearchData(e.target.value)}
                            />
                            <Button
                                type='button'
                                text='Buscar'
                                className='search-btn'
                                onClick={searchUser}
                                disabled={searchLoading}
                            />
                        </div>

                        {/* Search Results */}
                        {usersFound?.length > 0 ? (
                            <div className="select-container">
                                <Select
                                    fieldName="patient"
                                    styles="w-full rounded-md h-12"
                                    register={register}
                                    label={`Seleccionar ${type}`}
                                    required={true}
                                    error={errors?.patient}
                                    options={usersFound}
                                    disableFirstOption={false}
                                />
                            </div>
                        ) : usersFound?.length === 0 ? (
                            <div className='no-results'>
                                <span className="no-results-text">Sin resultados</span>
                            </div>
                        ) : null}
                    </div>

                    {/* Selected Employee Details */}
                    {selectedEmployee && (
                        <div className="form-section employee-details">
                            <div className='important-notice'>
                                <span className='notice-title'>IMPORTANTE</span>
                                <span className='notice-text'>Asegúrese que todos los datos estén correctos y actualizados</span>
                            </div>

                            <div className='employee-info'>
                                <div className="info-grid">
                                    <div className="info-labels">
                                        <p>Paciente</p>
                                        <p>DNI</p>
                                        <p>Teléfono</p>
                                        <p>Email</p>
                                    </div>
                                    <div className="info-values">
                                        <p className="font-semibold">
                                            {selectedEmployee?.name || "N/A"}
                                        </p>
                                        <p className="font-semibold">
                                            {selectedEmployee?.DNI || "N/A"}
                                        </p>
                                        <p className="font-semibold">
                                            {PhoneNumber(selectedEmployee?.phoneNumber) || "N/A"}
                                        </p>
                                        <p className="font-semibold">
                                            {selectedEmployee?.email || "N/A"}
                                        </p>
                                    </div>
                                </div>
                                <div className='edit-data-section'>
                                    <button
                                        type='button'
                                        className='edit-data-btn'
                                        onClick={() => openModal(UPDATE_PERSONAL_DATA_MODAL)}
                                    >
                                        Editar datos
                                    </button>
                                </div>
                            </div>

                            {/* Exam/Practice Selection */}
                            {chosenRole !== 'RRHH_ABSENTEE' && (
                                <div className="form-section">
                                    <SearchSelectFetch
                                        control={control}
                                        name="molde"
                                        label="Puestos (Exámenes sugeridos)"
                                        disabled={Boolean(exam)}
                                        fetchOptions={async () => {
                                            return fetchAndFilterMoldes(
                                                LavorisInstance,
                                                currentCompany?.id,
                                                type,
                                            );
                                        }}
                                        propertyLabel={"name"}
                                        inputStyles="rounded w-full h-[50px]"
                                    />
                                    {molde && (
                                        <div className="selected-item">
                                            <div className="pill-container">
                                                <PillButton
                                                    text={molde.name || molde.position.name}
                                                    onClick={() => resetField("molde")}
                                                />
                                            </div>
                                            <MoldeDetails molde={molde} />
                                        </div>
                                    )}

                                    <SearchSelectFetch
                                        control={control}
                                        name="exam"
                                        label="Examen"
                                        fetchOptions={async () =>
                                            LavorisInstance.ExamsMoldes.getExamsWithPracticesDataFilteredByPatientType(
                                                type,
                                            )
                                        }
                                        propertyLabel={"name"}
                                        inputStyles="rounded w-full h-[50px]"
                                        disabled={Boolean(molde)}
                                    />
                                    {exam && (
                                        <div className="selected-item">
                                            <div className="pill-container">
                                                <PillButton
                                                    key={`exam-${exam.id}`}
                                                    text={exam.name}
                                                    onClick={() => resetField("exam")}
                                                />
                                            </div>
                                            <ExamDetails exam={exam} />
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Individual Practices */}
                            <div className="form-section">
                                <SearchSelectFetch
                                    control={control}
                                    name="practiceSelector"
                                    label="Prácticas individuales"
                                    fetchOptions={async () => {
                                        return fetchAndFilterPractices(
                                            LavorisInstance,
                                            exam,
                                            molde,
                                            practicesSelected,
                                            type
                                        );
                                    }}
                                    propertyLabel={"name"}
                                    inputStyles="rounded w-full h-[50px]"
                                    onSelected={(data) => {
                                        const selected = practicesSelected?.length
                                            ? practicesSelected
                                            : [];
                                        setValue("practicesSelected", [...selected, data]);
                                    }}
                                />
                                {practicesSelected?.length >= 0 && (
                                    <PracticesPillows
                                        practices={practicesSelected}
                                        onClick={(practice: Practice) => {
                                            setValue(
                                                "practicesSelected",
                                                practicesSelected.filter((p: any) => p.id !== practice.id),
                                            );
                                        }}
                                    />
                                )}
                            </div>

                            {/* Medical Certificate */}
                            {practicesSelected?.some((p: Practice) => p.managerId === '1026') && (
                                <div className="form-section medical-certificate">
                                    <hr className="section-divider" />
                                    <InputRadioCM
                                        fieldName={"has_cm"}
                                        label={"¿Tiene Certificado Médico?"}
                                        register={register}
                                        error={errors.has_cm}
                                        required={true}
                                        getValues={getValues}
                                        setValue={setValue}
                                        readOnly={false}
                                        control={control}
                                    />
                                    <hr className="section-divider" />
                                </div>
                            )}

                            {/* Comments */}
                            <div className="form-section">
                                <Textarea
                                    fieldName="comments"
                                    label="Comentarios"
                                    register={register}
                                    error={errors?.comments}
                                    styles="rounded w-full mb-4"
                                    rows={8}
                                />
                            </div>

                            {/* File Upload */}
                            <div className="form-section">
                                <DynamicFileUpload
                                    label="Otro archivo (opcional)"
                                    updateFilesCb={updateUploadedFiles}
                                    maxFileSizeInBytes={500000}
                                    accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    multiple
                                    buttonText="Agregar otro archivo"
                                />
                            </div>

                            {/* Submit Button */}
                            <div className="submit-section">
                                {(!selectedEmployee.email || !selectedEmployee.phoneNumber) ? (
                                    <button
                                        type="button"
                                        className="w-full bg-slate-500 font-bold text-white mt-3 py-3 px-4 rounded disabled:opacity-50"
                                        disabled={true}
                                    >
                                        El postulante elegido debe tener un email y un teléfono válido
                                    </button>
                                ) : (
                                    <div className="w-full">
                                        <PrimaryButton
                                            type="submit"
                                            text={requestLoading ? 'Solicitando...' : 'Solicitar turno'}
                                            styles="bg-red-500 font-bold text-white mt-3 w-full py-3"
                                            disabled={requestLoading}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    </form>
                </div>
            </Modal>

            {isActive(UPDATE_PERSONAL_DATA_MODAL) && (
                <UpdatePersonalDataModal
                    show
                    urlTittle={UPDATE_PERSONAL_DATA_MODAL}
                    onClose={() => closeModal(UPDATE_PERSONAL_DATA_MODAL)}
                    modalTitle={"Actualizar Nombre, Email o Teléfono"}
                    user={selectedEmployee}
                    setUpdateEmailPhoneData={setUpdateEmailPhoneData}
                    submit={setIsSubmitted}
                />
            )}
        </div>
    );
}

const NewRequestPrestadorModal = (props: any) => {
    const controller = new AbortController();
    const signal = controller.signal;
    const LavorisInstance = LavorisService.getInstance();
    const { showAlert } = useAlert();
    const { openModal, closeModal, isActive } = useModal();
    const currentCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]);
    const [searchLoading, setSearchLoading] = useState<boolean>(false);
    const [type, setType] = useState<string>('Postulante')
    const [searchData, setSearchData] = useState<string>('')
    const [usersFound, setUsersFound] = useState<any | any[]>(null)
    const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
    const [selectedFiles, setSelectedFiles] = useState<SelectedFiles | null>(null);
    const [requestLoading, setRequestLoading] = useState<boolean>(false);
    const [updateEmailPhoneData, setUpdateEmailPhoneData] = useState<{ email: string, phoneNumber: string, name: string }>({ email: "", phoneNumber: "", name: "" });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [readOnlyInputRadio, setReadOnlyInputRadio] = useState(false);

    const searchUser = async () => {
        setSearchLoading(true);
        setReadOnlyInputRadio(true);
        try {
            setSelectedEmployee(null)
            let isEmployee = type === 'Empleado';

            const response = isEmployee
                ? await LavorisInstance.CompanyServices.getEmployeeWithQuery(currentCompany?.id, searchData, signal)
                : await LavorisInstance.CompanyServices.getCandidatesWithQuery(searchData, signal);

            const data = Array.isArray(response) ? response : response.data;
            setUsersFound(data);
            if (data.length === 1) setSelectedEmployee(data[0]);
        } catch (error) {
            console.error(error);
        } finally {
            setSearchLoading(false);
        }
    }

    const {
        register,
        handleSubmit,
        resetField,
        setValue,
        control,
        watch,
        reset,
        formState: { errors }
    } = useForm({
        mode: 'all'
    });

    const handleTypeChange = (newType: string) => {
        setType(newType);
        setSearchData('');
        setUsersFound(null);
        setSelectedEmployee(null);
        setSelectedFiles(null);
        reset();
    };

    // Resetear searchLoading cuando el modal se abre
    useEffect(() => {
        if (props.show) {
            setSearchLoading(false);
        }
    }, [props.show]);

    const [patient] = watch(['patient'])

    useEffect(() => {
        const normalizeString = (str: any) => {
            return str
                .trim()
                .replace(/\s+/g, ' ')
                .toLowerCase();
        };

        const chosenEmployee = usersFound?.find((e: any) => {
            const ename = e?.name?.split(',')[1]?.trim();
            const elastname = e?.name?.split(',')[0]?.trim();
            const efullname = `${elastname}, ${ename}`;

            const pname = patient?.split(',')[1]?.trim();
            const plastname = patient?.split(',')[0]?.trim();
            const pfullname = `${plastname}, ${pname}`;
            return normalizeString(efullname) === normalizeString(pfullname);
        });

        setSelectedEmployee(chosenEmployee);
    }, [patient]);

    const updateUploadedFiles = (files: File[]) =>
        setSelectedFiles({ ...selectedFiles, profileImages: files });

    const uploadFile = async (id: string, selectedFile: File) => {
        await LavorisInstance.TurnServices.addFile(
            { file: selectedFile },
            id,
        ).catch((e: any) => console.log(e));
    };

    const onSubmit = async (data: any) => {
        setRequestLoading(true);
        try {
            const patientId = selectedEmployee && selectedEmployee !== undefined && selectedEmployee?.id
            const patientType = type === 'Postulante' ? 'COMPANY_CANDIDATE' : 'COMPANY_EMPLOYEE';
            const dataToSubmit = {
                observations: data.comments,
                patientType: patientType,
                patientId,
            };

            const res = await LavorisInstance.TurnServices.RequestPrestadorTurnService(dataToSubmit)

            const filesToUpload = selectedFiles?.profileImages ?? [];
            if (res && filesToUpload.length) {
                await Promise.all(
                    filesToUpload.map((file) => uploadFile(res.appointment, file)),
                );
            }
            closeModal(REQUEST_PRESTADOR_MODAL);
            openModal(SUCCESS);
        } catch (err) {
            showAlert(getErrorMessage({ title: 'NO SE PUDO REALIZAR LA SOLICITUD.', err }))
        } finally {
            setRequestLoading(false);
        }
    };

    useEffect(() => {
        if (isSubmitted) {
            setSelectedEmployee({
                ...selectedEmployee,
                email: updateEmailPhoneData.email,
                phoneNumber: updateEmailPhoneData.phoneNumber,
                name: updateEmailPhoneData.name,
            })
            setIsSubmitted(false);
        }
    }, [isSubmitted])

    return (
        <div>
            <Modal
                show={props.show}
                modalTitle={props.modalTitle}
                urlTittle={props.urlTittle}
                onClose={props.onClose}
                titleStyle="text-2xl text-red-500 font-bold"
            >
                <div className="request-modal-content">
                    <form className='request-form' onSubmit={handleSubmit(onSubmit)}>
                    {/* Type Selection */}
                    <div className="form-section">
                    <InputRadioType
                            label="SELECCIONAR SEGÚN TIPO"
                            fieldName="type"
                            option1="Postulante"
                            option2="Empleado"
                            option1Legend="Estudios para ingresar al puesto"
                            option2Legend="Estudios para egreso y/o periódico, etc."
                            onChange={(e: any) => handleTypeChange(e)}
                            register={register}
                            defaultValue={'Postulante'}
                            //readOnly={readOnlyInputRadio}
                            error={errors?.type}
                        />
                    </div>

                    {/* Search Section */}
                    <div className="form-section">
                        <div className='search-user-group'>
                            <Input
                                type='text'
                                fieldName='searchuser'
                                label='Buscar por apellido, nombre o DNI'
                                register={register}
                                style={{ width: '100%', height: '90px' }}
                                onChange={(e: any) => setSearchData(e.target.value)}
                            />
                            <Button
                                type='button'
                                text='Buscar'
                                className='bg-green-700 text-lg text-white text-center p-auto m-auto'
                                onClick={searchUser}
                                disabled={searchLoading}
                            />
                        </div>

                        {/* Search Results */}
                        {usersFound?.length > 0 ? (
                            <div className="select-container">
                                <Select
                                    fieldName="patient"
                                    styles="w-full rounded-md h-12"
                                    register={register}
                                    label={`Seleccionar ${type}`}
                                    required={!usersFound}
                                    error={errors?.patient}
                                    options={usersFound}
                                />
                            </div>
                        ) : usersFound?.length === 0 ? (
                            <div className='no-results'>
                                <h2>Sin resultados</h2>
                            </div>
                        ) : null}
                    </div>

                    {/* Selected Employee Details */}
                    {selectedEmployee && (
                        <div className="form-section employee-details">
                            <div className='employee-info prestador-info'>
                                <div className="info-grid">
                                    <div className="info-labels">
                                        <p>Paciente</p>
                                        <p>DNI</p>
                                        <p>Teléfono</p>
                                        <p>Email</p>
                                        <p>Dirección</p>
                                    </div>
                                    <div className="info-values">
                                        <p className="font-semibold">
                                            {selectedEmployee?.name || "N/A"}
                                        </p>
                                        <p className="font-semibold">
                                            {selectedEmployee?.DNI || "N/A"}
                                        </p>
                                        <p className="font-semibold">
                                            {PhoneNumber(selectedEmployee?.phoneNumber) || "N/A"}
                                        </p>
                                        <p className="font-semibold">
                                            {selectedEmployee?.email || "N/A"}
                                        </p>
                                        <p className="font-semibold">
                                            {selectedEmployee?.fullAddress || "N/A"}
                                        </p>
                                    </div>
                                </div>
                                <div className='edit-data-section'>
                                    <button
                                        type='button'
                                        className='flex justify-center align-middle text-white bg-blue-700 m-auto p-3 rounded-lg hover:bg-blue-900'
                                        onClick={() => openModal(UPDATE_PERSONAL_DATA_MODAL)}
                                    >
                                        Editar datos
                                    </button>
                                </div>
                            </div>

                            {/* Information Requirements */}
                            <div className="form-section requirements-section">
                                <div className="requirements-notice">
                                    <label className="text-center text-xl text-red-600 font-extrabold underline">INFORMACIÓN OBLIGATORIA</label>
                                    <ul className="list-disc pl-6 mt-2">
                                        <li>Ubicación actual del {type === 'Postulante' ? 'postulante' : 'empleado'} (ciudad, localidad y provincia)</li>
                                        <li>{type === 'Postulante' ? 'Examen Ingreso' : 'Examen Periódico o Egreso'}, prácticas</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Comments */}
                            <div className="form-section">
                                <Textarea
                                    fieldName="comments"
                                    label="Comentarios"
                                    register={register}
                                    error={errors?.comments}
                                    styles="rounded w-full mb-4"
                                    rows={8}
                                />
                            </div>

                            {/* File Upload */}
                            <div className="form-section">
                                <DynamicFileUpload
                                    label="Otro archivo (opcional)"
                                    updateFilesCb={updateUploadedFiles}
                                    maxFileSizeInBytes={500000}
                                    accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    multiple
                                    buttonText="Agregar otro archivo"
                                />
                            </div>

                            {/* Submit Button */}
                            <div className="submit-section">
                                {(!selectedEmployee.email || !selectedEmployee.phoneNumber) ? (
                                    <button
                                        type="button"
                                        className="w-full bg-slate-500 font-bold text-white mt-3 py-3 px-4 rounded disabled:opacity-50"
                                        disabled={true}
                                    >
                                        El postulante elegido debe tener un email y un teléfono válido
                                    </button>
                                ) : (
                                    <div className="w-full">
                                        <PrimaryButton
                                            type="submit"
                                            text={requestLoading ? 'Solicitando...' : 'Solicitar turno'}
                                            styles="bg-red-500 font-bold text-white mt-3 w-full py-3"
                                            disabled={requestLoading}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    </form>
                </div>
            </Modal>

            {isActive(UPDATE_PERSONAL_DATA_MODAL) && (
                <UpdatePersonalDataModal
                    show
                    urlTittle={UPDATE_PERSONAL_DATA_MODAL}
                    onClose={() => closeModal(UPDATE_PERSONAL_DATA_MODAL)}
                    modalTitle={"Actualizar Nombre, Email o Teléfono"}
                    user={selectedEmployee}
                    setUpdateEmailPhoneData={setUpdateEmailPhoneData}
                    submit={setIsSubmitted}
                />
            )}
        </div>
    );
}

const RequestTurns = () => {
    const { openModal, closeModal, isActive } = useModal();

    return (
        <div className="">
            {/* Request Options */}
            <div className="request-options">
                <div className="option-card">
                    <div className="option-content">
                        <div className="option-icon lavoris-icon">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z" fill="currentColor" />
                            </svg>
                        </div>
                        <div className="option-info">
                            <h3 className="option-title">Turno Individual - Clínica Lavoris</h3>
                            <p className="option-description">
                                Solicitar turno para un postulante o empleado en la sede principal
                            </p>
                            <span className="option-location">Rodríguez Peña 59, CBA</span>
                        </div>
                    </div>
                    <button
                        className="option-btn primary-btn"
                        onClick={() => openModal(REQUEST_TURN_MODAL)}
                    >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M8 3.333v9.334M3.333 8h9.334" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Solicitar
                    </button>
                </div>

                <div className="option-card">
                    <div className="option-content">
                        <div className="option-icon multiple-icon">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zM4 18v-4h3v4h2v-7.5c0-1.1-.9-2-2-2s-2 .9-2 2V18H4zm14-7.5c0-1.1-.9-2-2-2s-2 .9-2 2V18h2v-4h3v4h2v-7.5zm-7-1.5c0-1.11-.89-2-2-2s-2 .89-2 2 .89 2 2 2 2-.89 2-2zm-2 3.5c-1.1 0-2 .9-2 2V18h2v-4h3v4h2v-7.5c0-1.1-.9-2-2-2s-2 .9-2 2z" fill="currentColor" />
                            </svg>
                        </div>
                        <div className="option-info">
                            <h3 className="option-title">Turnos Múltiples - Postulantes</h3>
                            <p className="option-description">
                                Solicitar varios turnos simultáneamente para múltiples postulantes
                            </p>
                            <span className="option-location">Rodríguez Peña 59, CBA</span>
                        </div>
                    </div>
                    <button
                        className="option-btn secondary-btn"
                        onClick={() => openModal(APPLICANTS_MULTIPLE_REQUEST_TURN_MODAL)}
                    >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M8 3.333v9.334M3.333 8h9.334" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Solicitar Múltiples
                    </button>
                </div>

                <div className="option-card">
                    <div className="option-content">
                        <div className="option-icon external-icon">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-.61.08-1.21.21-1.78L8.99 15v1c0 1.1.9 2 2 2v1.93C7.06 19.43 4 16.07 4 12zm13.89 5.4c-.26-.81-1-1.4-1.89-1.4h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41C17.92 5.77 20 8.65 20 12c0 2.08-.81 3.98-2.11 5.4z" fill="currentColor" />
                            </svg>
                        </div>
                        <div className="option-info">
                            <h3 className="option-title">Turno Externo - Clínica Externa</h3>
                            <p className="option-description">
                                Solicitar exámenes en clínicas del interior del país
                            </p>
                            <span className="option-location">Prestadores en todo el país</span>
                        </div>
                    </div>
                    <button
                        className="option-btn external-btn"
                        onClick={() => openModal(REQUEST_PRESTADOR_MODAL)}
                    >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M8 3.333v9.334M3.333 8h9.334" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Solicitar Externo
                    </button>
                </div>
            </div>

            {/* Footer Information */}
            <div className="footer-info">
                <div className="info-box">
                    <div className="info-icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666ZM10 15a1.25 1.25 0 1 1 0-2.5A1.25 1.25 0 0 1 10 15Zm1.25-4.167H8.75V6.25h2.5v4.583Z" fill="currentColor" />
                        </svg>
                    </div>
                    <div className="info-content">
                        <h4>Importante</h4>
                        <p>
                            Una vez enviada la solicitud, podrá hacer seguimiento del estado en la pantalla de "Solicitudes".
                            Se le notificará por email cuando el turno sea confirmado.
                        </p>
                    </div>
                </div>
            </div>

            {/* Modals */}
            {isActive(REQUEST_TURN_MODAL) && (
                <NewRequestModal
                    show
                    urlTittle={REQUEST_TURN_MODAL}
                    onClose={() => closeModal(REQUEST_TURN_MODAL)}
                    modalTitle={"Solicitar turno en Lavoris"}
                />
            )}

            {isActive(APPLICANTS_MULTIPLE_REQUEST_TURN_MODAL) && (
                <NewRequestsMultipleApplicantsModal
                    show
                    urlTittle={APPLICANTS_MULTIPLE_REQUEST_TURN_MODAL}
                    onClose={() => closeModal(APPLICANTS_MULTIPLE_REQUEST_TURN_MODAL)}
                    modalTitle={"Solicitar turnos múltiples - Postulantes"}
                />
            )}

            {isActive(EMPLOYEES_MULTIPLE_REQUEST_TURN_MODAL) && (
                <NewRequestsMultipleEmployeesModal
                    show
                    urlTittle={EMPLOYEES_MULTIPLE_REQUEST_TURN_MODAL}
                    onClose={() => closeModal(EMPLOYEES_MULTIPLE_REQUEST_TURN_MODAL)}
                    modalTitle={"Solicitar turnos múltiples - Empleados"}
                />
            )}

            {isActive(REQUEST_PRESTADOR_MODAL) && (
                <NewRequestPrestadorModal
                    show
                    urlTittle={REQUEST_PRESTADOR_MODAL}
                    onClose={() => closeModal(REQUEST_PRESTADOR_MODAL)}
                    modalTitle={"Solicitar turno externo"}
                />
            )}

            {isActive(SUCCESS) && (
                <SuccessModal
                    show
                    urlTittle={SUCCESS}
                    modalTitle={'SOLICITUD CREADA EXITOSAMENTE.'}
                    modalSubtitle={'Podras consultarla a través de la solapa "Solicitudes"'}
                    onClose={() => { closeModal(SUCCESS) }}
                />
            )}
        </div>
    );
}

export default RequestTurns;